import * as React from 'react'

import { Skeleton } from '@thg-commerce/gravity-elements'
import { styled, spacing } from '@thg-commerce/gravity-theme'

export const Tags = styled(Skeleton)<{ width?: string }>`
  display: inline-block;
  width: ${(props) => props.width || '78px'};
  height: 37px;
  margin-right: ${spacing(1)};
  margin: ${spacing(1)} 0;
`

export const TagsSkeleton = () => {
  return (
    <React.Fragment>
      <Tags />
      <Tags width="106px" />
      <Tags width="139px" />
    </React.Fragment>
  )
}
